import React, { PropsWithChildren } from 'react'
import { Flex, Box } from 'rebass/styled-components'
import Modal from 'styled-react-modal';
import { SpecialModalBackground } from './Commons';
import styled from 'styled-components';


const Wrapper = styled(Flex)`
  overflow: auto;
  width: auto;
  padding-right: 20px;
  margin-right: 20px;
  padding-left: 40px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

interface IEnhancedModalProps {
  onClose: () => void
  isOpen: boolean
  canCloseOnBackgroundClick?: boolean,
  canCloseOnEscape?: boolean,
  containerStyle?: React.CSSProperties
}

export const EnhancedModal: React.FC<IEnhancedModalProps & PropsWithChildren> = ({
  children,
  onClose,
  isOpen,
  canCloseOnBackgroundClick = true,
  canCloseOnEscape = true,
  containerStyle = {}
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onBackgroundClick={() => {
        if (!canCloseOnBackgroundClick) return
        onClose();
      }}
      onEscapeKeydown={() => {
        if (!canCloseOnEscape) return
        onClose()
      }}
    >
      <SpecialModalBackground
        onClick={() => {
          if (!canCloseOnBackgroundClick) return
          onClose()
        }}
      >
        <Box
          style={{
            margin: '0 auto',
            alignSelf: 'center',
            borderRadius: '20px',
            position: 'relative',
            background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
            padding: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            maxWidth: '95vw',
            minWidth: 'initial',
            maxHeight: '95vh',
            minHeight: '90px',
            overflowY: 'hidden'
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Wrapper flex={1} flexDirection={'column'} style={{
            overflowY: 'auto',
            ...containerStyle
          }}>
            {children}
          </Wrapper>
        </Box>
      </SpecialModalBackground>
    </Modal>);
}